import _ from 'lodash';
import moment from 'moment';

import { xml2json } from '../../form-designer/utils/runtime.utils';
import { DATE_FORMAT_WITH_TIMESTAMP } from '../../utils/dateUtils';

export const equalityFn = (prev, next) => _.isEqual(prev, next);

export const normalizeData = (object) => {
  if (object === undefined || object === null) {
    return object;
  }
  const tempStr = JSON.stringify(object);
  const regexTrue = /"true"/g;
  const regexFalse = /"false"/g;
  return JSON.parse(tempStr.replace(regexTrue, true).replace(regexFalse, false));
};

export const difference = (object, base) => {
  function changes(object, base) {
    return _.transform(object, function(result, value, key) {
      if (!_.isEqual(normalizeData(value), normalizeData(base[key]))) {
        result[key] =
          _.isObject(value) && _.isObject(base[key]) ? changes(value, base[key]) : value;
      }
    });
  }

  return changes(object, base);
};

export const modifyDate = (date) => {
  if (!moment(date).isValid()) {
    return;
  }

  return moment(date).format(DATE_FORMAT_WITH_TIMESTAMP);
};

export const findTreeItemById = (tree, id) => {
  for (const i of tree.InnerTreeBranches) {
    for (const j of i.InnerTreeBranches) {
      for (const k of j.InnerTreeLeaves) {
        if (k.Id === id) {
          return k;
        }
      }
    }
  }
};

export const findAllChildViews = (views, id, childViews) => {
  for (const view of views) {
    if (view.ParentId === id) {
      childViews.push(view.Id);

      view.HasChildren && findAllChildViews(views, view.Id, childViews);
    }
  }
};

export const findAllChildViewsLevel = (views, id, childViews, level) => {
  for (const view of views) {
    if (view.ParentId === id) {
      childViews.push(level);

      view.HasChildren && findAllChildViewsLevel(views, view.Id, childViews, level + 1);
    }
  }
};

export const updateViewsAfterDeleteView = (views, id) => {
  const viewsIdsToDelete = [];

  findAllChildViews(views, id, viewsIdsToDelete);

  const updatedViewsWithDeletedChildren = views.filter(
    (view) => view.Id !== id && !viewsIdsToDelete.includes(view.Id)
  );

  const updatedViews = updatedViewsWithDeletedChildren.map((view) => {
    const hasChildren = updatedViewsWithDeletedChildren.find((v) => v.ParentId === view.Id);

    return { ...view, HasChildren: !!hasChildren };
  });

  return updatedViews;
};

export const createSavePayload = (info, views, isSaveAs, reportName) => {
  return isSaveAs
    ? {
        ReportPackage: {
          SsReportInfo: {
            ...info,
            ReportKey: reportName,
            ReportModel: reportName,
            ReportModelName: reportName,
          },
          ReportDesign: {
            ReportModel: {
              Views: views,
            },
          },
          ReportModel: reportName,
        },
        isSaveAs,
      }
    : {
        ReportPackage: {
          SsReportInfo: {
            ...info,
          },
          ReportDesign: {
            ReportModel: {
              Views: views,
            },
          },
          ReportModel: info.ReportKey,
        },
      };
};

export const validateReportModelXml = ({ xml, errorMessage }) => {
  const parsedJson = xml2json(xml);
  const { reportDesign, ssReportInfo } = parsedJson?.reportPackage ?? {};

  if (!reportDesign?.reportModel || !ssReportInfo) {
    throw new Error(errorMessage);
  }
};
